// Image imports for properties
// Property 1
import proper1_1 from './properties/proper1/1.jpeg';
import proper1_2 from './properties/proper1/2.jpeg';
import proper1_3 from './properties/proper1/3.jpeg';
import proper1_4 from './properties/proper1/4.jpeg';
import proper1_5 from './properties/proper1/5.jpeg';
import proper1_6 from './properties/proper1/6.jpeg';
import proper1_7 from './properties/proper1/7.jpeg';
import proper1_8 from './properties/proper1/8.jpeg';
import proper1_9 from './properties/proper1/9.jpeg';
import proper1_10 from './properties/proper1/10.jpeg';
import proper1_11 from './properties/proper1/11.jpeg';
import proper1_12 from './properties/proper1/12.jpeg';
import proper1_13 from './properties/proper1/13.jpeg';
import proper1_14 from './properties/proper1/14.jpeg';
import proper1_15 from './properties/proper1/15.jpeg';

// Property 2
import proper2_1 from './properties/proper2/1.jpeg';
import proper2_2 from './properties/proper2/2.jpeg';
import proper2_3 from './properties/proper2/3.jpeg';
import proper2_4 from './properties/proper2/4.jpeg';
import proper2_5 from './properties/proper2/5.jpeg';
import proper2_6 from './properties/proper2/6.jpeg';
import proper2_7 from './properties/proper2/7.jpeg';
import proper2_8 from './properties/proper2/8.jpeg';
import proper2_9 from './properties/proper2/9.jpeg';
import proper2_10 from './properties/proper2/10.jpeg';
import proper2_11 from './properties/proper2/11.jpeg';
import proper2_12 from './properties/proper2/12.jpeg';
import proper2_13 from './properties/proper2/13.jpeg';
import proper2_14 from './properties/proper2/14.jpeg';
import proper2_15 from './properties/proper2/15.jpeg';
import proper2_16 from './properties/proper2/16.jpeg';

// Property 3
import proper3_1 from './properties/proper3/1.jpeg';
import proper3_2 from './properties/proper3/2.jpeg';
import proper3_3 from './properties/proper3/3.jpeg';
import proper3_4 from './properties/proper3/4.jpeg';
import proper3_5 from './properties/proper3/5.jpeg';
import proper3_6 from './properties/proper3/6.jpeg';
import proper3_7 from './properties/proper3/7.jpeg';
import proper3_8 from './properties/proper3/8.jpeg';
import proper3_9 from './properties/proper3/9.jpeg';
import proper3_10 from './properties/proper3/10.jpeg';
import proper3_11 from './properties/proper3/11.jpeg';
import proper3_12 from './properties/proper3/12.jpeg';
import proper3_13 from './properties/proper3/13.jpeg';
import proper3_14 from './properties/proper3/14.jpeg';
import proper3_15 from './properties/proper3/15.jpeg';
import proper3_16 from './properties/proper3/16.jpeg';


// Property images configuration
export const propertyImages = {
  obsidianMonolith: [
    proper1_1,
    proper1_2,
    proper1_3,
    proper1_4,
    proper1_5,
    proper1_6,
    proper1_7,
    proper1_8,
    proper1_9,
    proper1_10,
    proper1_11,
    proper1_12,
    proper1_13,
    proper1_14,
    proper1_15
  ],
  villaAzure: [
    proper2_1,
    proper2_2,
    proper2_3,
    proper2_4,
    proper2_5,
    proper2_6,
    proper2_7,
    proper2_8,
    proper2_9,
    proper2_10,
    proper2_11,
    proper2_12,
    proper2_13,
    proper2_14,
    proper2_15,
    proper2_16
  ],
  sandstoneSolace: [
    proper3_1,
    proper3_2,
    proper3_3,
    proper3_4,
    proper3_5,
    proper3_6,
    proper3_7,
    proper3_8,
    proper3_9,
    proper3_10,
    proper3_11,
    proper3_12,
    proper3_13,
    proper3_14,
    proper3_15,
    proper3_16
  ]
};

// Helper function to get property images
export const getPropertyImages = (propertyKey) => {
  return propertyImages[propertyKey] || [];
};

// Made with Bob
